import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Profile from './views/Profile.vue'
import Index from './views/Index.vue'
import Login from './views/Login.vue'
import Tpl from './components/Tpl.vue'
import Equipment from './views/equipment/Equipment.vue'
import EquipmentDetail from './views/equipment/Detail.vue'
import Merchant from './views/merchant/Merchant.vue'
import EqHelper from './views/eqhelper/List.vue'
import MerchantDetail from './views/merchant/Detail.vue'
import Agent from './views/agent/Agent.vue'
import AgAccount from './views/agent/AgAccount.vue'
import AgentDetail from './views/agent/Detail.vue'
import Model from './views/Model.vue'
import Adv from './views/Marketing/Adv/index.vue'
import AdvList from './views/Marketing/AdvList/index.vue'
import repair from './views/Marketing/repair/index.vue'
import device from './views/device/index.vue'
import Corpus from './views/Corpus/index.vue'
import mch from './views/mchList/index.vue'


import agent from './views/squeaky/agent/index.vue'
import agentDevice from './views/squeaky/device/index.vue'
import agentDeviceDetail from './views/squeaky/device/detail.vue'


import Developer from './views/Developer.vue'
import Upgrade from './views/upgrade/Upgrade.vue'
import UpgradeDetail from './views/upgrade/Detail.vue'
import UpgradeDetail1 from './views/upgrade/Detail1.vue'
import Itask from './views/itask/List.vue'
import Param from './views/param/List.vue'
import ParamDt from './views/param/Detail.vue'
import locales from '@/components/language/app.js'
var curLang = locales[localStorage.lang_jp]


Vue.use(Router)


let Marketing = {
	path: '/Marketing/Adv',
	// name: '营销广告',
	name: curLang.menu.Marketing,
	component: Tpl,
	meta: {
		icon: 'el-icon-setting',
		folder: true
	},
	children: [
		{
		path: '/Marketing/Adv',
		// name: '广告审核',
		name: curLang.menu.Adv,
		component: Tpl,
		children: [{
			path: '/Marketing/Adv',
			name: '',
			component: Adv
		}]
	},
	{
		path: '/Marketing/AdvList',
		// name: '广告列表',
		name: curLang.menu.AdvList,
		component: Tpl,
		children: [{
			path: '/Marketing/AdvList',
			name: '',
			component: AdvList
		}]
	},
	{
		path: '/Marketing/mch',
		// name: '广告列表',
		name: curLang.menu.mchtList,
		component: Tpl,
		children: [{
			path: '/Marketing/mch',
			name: '',
			component: mch
		}]
	},
	{
		path: '/Marketing/Corpus',
		// name: '广告列表',
		name: curLang.menu.LanguageList,
		component: Tpl,
		children: [{
			path: '/Marketing/Corpus',
			name: '',
			component: Corpus
		}]
	},{
		path: '/Marketing/device',
		// name: '广告列表',
		name: curLang.menu.deviceList,
		component: Tpl,
		children: [{
			path: '/Marketing/device',
			name: '',
			component: device
		}]
	},{
		path: '/Marketing/repair',
		// name: '广告列表',
		name: curLang.menu.repair,
		component: Tpl,
		children: [{
			path: '/Marketing/repair',
			name: '',
			component: repair
		}]
	},
	]
}

let r_index = {
	path: '/',
	// name: '首页',
	name: curLang.menu.home,
	meta: {
		icon: 'el-icon-odometer'
	},
	component: Index
}

let r_equip = {
	path: '/equipment',
	// name: '设备管理',
	name: curLang.menu.device_management,
	component: Tpl,
	meta: {
		icon: 'el-icon-monitor'
	},
	children: [{
		path: '/equipment',
		name: '',
		component: Equipment
	},
	{
		path: '/equipment/detail',
		// name: '设备详情',
		name: curLang.menu.device_detail,
		component: EquipmentDetail
	}
	]
}

let r_merchant = {
	path: '/merchant',
	// name: '商户管理',
	name: curLang.menu.merchant_management,
	component: Tpl,
	meta: {
		icon: 'el-icon-shopping-bag-1'
	},
	children: [{
		path: '/merchant',
		name: '',
		component: Merchant
	},
	{
		path: '/merchant/detail',
		// name: '商户详情',
		name: curLang.menu.merchant_detail,
		component: MerchantDetail
	}
	]
}

let r_eqhelper = {
	path: '/eqhelper',
	// name: '设备助手',
	name: curLang.menu.device_assistant,
	component: Tpl,
	meta: {
		icon: 'el-icon-connection'
	},
	children: [{
		path: '/eqhelper',
		name: '',
		component: EqHelper
	}]
}


let r_agent = {
	path: '/agent',
	// name: '渠道商管理',
	name: curLang.menu.channel_vendor_management,
	component: Tpl,
	meta: {
		icon: 'el-icon-office-building'
	},
	children: [{
		path: '/agent',
		name: '',
		component: Agent
	},
	{
		path: '/agent/detail',
		// name: '渠道商详情',
		name: curLang.menu.channel_vendor_detail,
		component: AgentDetail
	}
	]
}

let r_profile = {
	path: '/profile',
	// name: '个人信息',
	name: curLang.menu.personal_information,
	component: Tpl,
	meta: {
		icon: 'el-icon-user'
	},
	children: [{
		path: '/profile',
		name: '',
		component: Profile
	}]
}

let r_config = {
	path: '/config/model',
	// name: '平台配置',
	name: curLang.menu.platform_configuration,
	component: Tpl,
	meta: {
		icon: 'el-icon-setting',
		folder: true
	},
	children: [{
		path: '/config/model',
		// name: '产品管理',
		name: curLang.menu.model_management,
		component: Tpl,
		children: [{
			path: '/config/model',
			name: '',
			component: Model
		}]
	},
	{
		path: '/config/aguser',
		// name: '渠道商账号管理',
		name: curLang.menu.account_management,
		component: AgAccount
	},
	{
		path: '/config/param',
		// name: '参数管理',
		name: curLang.menu.parameter_management,
		component: Tpl,
		children: [{
			path: '/config/param',
			name: '',
			component: Param
		},
		{
			path: '/config/param/detail',
			name: '',
			component: ParamDt
		}
		]
	}
	]
}

let r_squeaky = {
	path: '/squeaky/index',
	name: '支音计划',
	// name: curLang.menu.platform_configuration,
	component: Tpl,
	meta: {
		icon: 'el-icon-setting',
		folder: true
	},
	children: [{
		path: '/squeaky/index',
		name: '渠道商管理',
		// name: curLang.menu.model_management,
		component: Tpl,
		children: [{
			path: '/squeaky/index',
			name: '',
			component: agent
		}]
	},
	{
		path: '/squeaky/device',
		name: '设备管理',
		component: Tpl,
		children: [{
			path: '/squeaky/device',
			name: '',
			component: agentDevice
		},
		{
			path: '/squeaky/device/detail',
			name: '设备详情',
			component: agentDeviceDetail
		}
		]
	},
		// {
		// 	path: '/config/param',
		// 	// name: '参数管理',
		// 	name: curLang.menu.parameter_management,
		// 	component: Tpl,
		// 	children: [{
		// 			path: '/config/param',
		// 			name: '',
		// 			component: Param
		// 		},
		// 		{
		// 			path: '/config/param/detail',
		// 			name: '',
		// 			component: ParamDt
		// 		}
		// 	]
		// }
	]
}




let r_config_omcmg = {
	path: '/config/aguser',
	// name: '平台配置',
	name: curLang.menu.platform_configuration,
	component: Tpl,
	meta: {
		icon: 'el-icon-setting',
		folder: true
	},
	children: [{
		path: '/config/aguser',
		// name: '渠道商帐号管理',
		name: curLang.menu.account_management,
		component: AgAccount
	},
	{
		path: '/config/param',
		// name: '参数管理',
		name: curLang.menu.parameter_management,
		component: Tpl,
		children: [{
			path: '/config/param',
			name: '',
			component: Param
		},
		{
			path: '/config/param/detail',
			name: '',
			component: ParamDt
		}
		]
	}
	]
}

let r_dev = {
	path: '/developer',
	// name: '开发者管理',
	name: curLang.menu.developer_management,
	component: Tpl,
	meta: {
		icon: 'el-icon-cpu'
	},
	children: [{
		path: '/developer',
		name: '',
		component: Developer
	}]
}

let r_upgrade = {
	path: '/upgrade',
	// name: '升级管理',
	name: curLang.menu.upgrade_management,
	component: Tpl,
	meta: {
		icon: 'el-icon-upload2 '
	},
	children: [{
		path: '/upgrade',
		name: '',
		component: Upgrade
	},
	{
		path: '/upgrade/detail',
		// name: '任务详情',
		name: curLang.menu.upgrade_management,
		component: Tpl,
		children: [{
			path: '/upgrade/detail',
			// name: '任务详情',
			name: curLang.menu.task_details,
			component: UpgradeDetail
		},
			// {
			//   path: '/upgrade/detail/sdetail',
			//   name: '子任务详情',
			//   component: UpgradeDetail1
			// }
		]
	},
	{
		path: '/upgrade/sdetail',
		// name: '子任务详情',
		name: curLang.menu.subtask_details,
		component: UpgradeDetail1
	},

	]
}

let r_itask = {
	path: '/itask',
	// name: '导入任务管理',
	name: curLang.menu.import_task_management,
	component: Tpl,
	meta: {
		icon: 'el-icon-document-copy'
	},
	children: [{
		path: '/itask',
		name: '',
		component: Itask
	}]
}

let r_login = {
	path: '/login',
	// name: '登录',
	name: curLang.menu.login,
	component: Login
}

/////////// make router
function rgetTmp(prop) {
	if (JSON && localStorage.ch_tmp) {
		var obj = JSON.parse(localStorage.ch_tmp)
		if (!obj) {
			return ''
		} else {
			return obj[prop]
		}
	} else {
		return ''
	}
}

var user = rgetTmp('user')
let rts = []
///////user.roleName === 'Admin'
user = user ? user : {
	roleName: ''
}
// alert(user.roleName)
switch (user.roleName) {
	case 'Admin':
		rts = [{
			path: '/',
			name: 'home',
			component: Home,
			children: [
				r_index,
				r_equip,
				r_merchant,
				r_agent,
				r_profile,
				// Marketing,
				r_config,
				r_squeaky,
				r_dev,
				r_upgrade,
				r_itask,
				r_eqhelper, 
			]
		},
			r_login
		]
		break
	case 'Agent':
		rts = [{
			path: '/',
			name: 'home',
			component: Home,
			children: [
				r_index,
				r_equip,
				r_merchant,
				r_profile
			]
		},
			r_login
		]
		break
	case 'Production':
		rts = [{
			path: '/',
			name: 'home',
			component: Home,
			children: [
				r_index,
				r_equip,
				r_upgrade,
				r_eqhelper,
				r_profile
			]
		},
			r_login
		]
		break
	case 'Ordinary':
		rts = [{
			path: '/',
			name: 'home',
			component: Home,
			children: [
				r_index,
				r_equip,
				r_merchant,
				r_agent,
				r_config_omcmg,
				r_profile,
				// r_eqhelper
				r_upgrade,
			]
		},
			r_login
		]
		break
	default:
		rts = [{
			path: '/',
			name: 'home',
			component: Home,
			children: [
				r_index,
			]
		},
			r_login
		]
		break
}

export default new Router({
	routes: rts
})
